const Promotions: React.FC = () => {
	return (
		<div className="live-chat-promotions-container">
		</div>
	);
};

export default Promotions;
